module.exports = __webpack_public_path__ + "static/SearchVideoMobileES-82bd65c0293a6e89c31fcd099e83e0ba.mp4";